import PropTypes from 'prop-types'
import { Text, Icon } from '@leroy-merlin-br/backyard-react-ui'
import {
  InfoCircle,
  AlertTriangle,
  TimesCircle,
  CheckmarkCircle
} from '@leroy-merlin-br/backyard-react-icons'

import * as S from './styled'

const icons = {
  info: InfoCircle,
  warning: AlertTriangle,
  success: CheckmarkCircle,
  critical: TimesCircle
}

const AlertMessage = ({ type = 'info', title = '', isStretch = true, children, customIcon }) => {
  const isTypeValid = Object.keys(icons).includes(type)

  if (!isTypeValid) {
    return null
  }

  return (
    <S.AlertMessage type={type} isStretch={isStretch}>
      <Icon as={customIcon || icons[type]} size="mega" />

      <S.Message>
        {title && (
          <Text size="kilo" bold noMargin>
            {title}
          </Text>
        )}

        {children && (
          <Text size="kilo" noMargin>
            {children}
          </Text>
        )}
      </S.Message>
    </S.AlertMessage>
  )
}

AlertMessage.propTypes = {
  type: PropTypes.oneOf(Object.keys(icons)).isRequired,
  title: PropTypes.string,
  isStretch: PropTypes.bool,
  children: PropTypes.node
}

export default AlertMessage
